import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase, AngularFireList,AngularFireAction } from '@angular/fire/database';
import { Observable, Subscription, BehaviorSubject,Subject} from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {formatDate} from '@angular/common';
//import { switchMap } 'rxjs';

import * as jspdf from 'jspdf';  
  
import html2canvas from 'html2canvas';  


@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.css']
})
export class ReportingComponent implements OnInit {

  //const size$ = new Subject<string>();
  
  //constructor() { }
  

  constructor(private db:AngularFireDatabase) { }
  datas:Observable<any[]>;
  dataT:Observable<any[]>;
  dataE:Observable<any[]>;
  dataF:Observable<any[]>;
  dataG:Observable<any[]>;
  sValue:any;
  dValue:any;
  date:any;
  advn:any;
  ngOnInit() {
    this.datas = this.db.list("Reporting").snapshotChanges();
  }

    

  
  searchVehicle(data:string){
    //this.dataE= this.db.list("Reporting/" + data).snapshotChanges();
       this.dataF=null;
       this.dataG=null;
       this.sValue = data;      
       //console.log(searchData);
       this.dataE=this.db.list('Reporting').snapshotChanges();
       
  }

  
  searchDate(date:string){

      //alert(date);
     this.dataE=null;
     this.dataG=null;
     this.dValue=date;
     this.dataF= this.db.list("Reporting").snapshotChanges();

     // this.date=formatDate(new Date(), 'yyyy/MM/dd', 'en');
     //this.date= new Date();
     //alert(this.date);
  
  }

  advName(data:string){
    this.dataF=null;
    this.dataE=null;
    this.advn=data;
    this.dataG=this.db.list("Reporting").snapshotChanges();

  }


   details(key:string){
    //DETAILS
    this.dataT= null;
    this.dataT = this.db.list("Reporting/" + key + "/log").snapshotChanges();

    

  }

  public captureScreen()  
  {  
    var data = document.getElementById('contentToConvert');  
    html2canvas(data).then(canvas => {  
      // Few necessary setting options  
      var imgWidth = 208;   
      var pageHeight = 295;    
      var imgHeight = canvas.height * imgWidth / canvas.width;  
      var heightLeft = imgHeight;  
  
      const contentDataURL = canvas.toDataURL('image/png')  
      let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF  
      var position = 0;  
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)  
      pdf.save('MYPdf.pdf'); // Generated PDF   
    });  
  }  

 



}
